import type { PiniaColadaOptions } from '@pinia/colada'
import { PiniaColadaIndexedDB } from './app/pinia-colada-plugins/colada-indexeddb'

export default {
  plugins: [
    PiniaColadaIndexedDB({
      defaultPersist: true,
      keyPrefix: 'colada:idb',
      storeName: 'admin',
    }),
  ],
} satisfies PiniaColadaOptions
